import * as React from 'react'
import * as plume from '@ulule/owl-kit-components/next'

import { Container } from '../../_shared/Container'
import { ILLUSTRATIONS } from '../content'
import { SectionHead } from '../../_shared/SectionHead'
import styles from './Illustrations.module.css'

export function Illustrations(): React.ReactElement {
  return (
    <section className={styles.illustrations} id="illustrations">
      <Container>
        <SectionHead
          size="lg"
          title="Illustrations libres de droit"
          lede="Ces visuels sont librement utilisables dans le cadre de publications journalistiques ou éditoriales mentionnant Ulule."
        />
        <div className={styles.illustrations__grid}>
          {ILLUSTRATIONS.map((illustration) => (
            <figure key={illustration.image} className={styles.illustration}>
              <div className={styles.illustration__img}>
                <img src={illustration.image} alt={illustration.caption} loading="lazy" />
              </div>
              <figcaption className={styles.illustration__foot}>
                <span className={styles.illustration__caption}>{illustration.caption}</span>
                {/* In prod these are offloaded to a cross-origin CDN, where the `download` attribute
                    is ignored; open in a new tab so the press page isn't navigated away from (and the
                    visual can still be saved from there). `download` still applies in same-origin dev. */}
                <plume.RoundButton
                  as="a"
                  href={illustration.image}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  color="black"
                  kind="secondary"
                  prefixIcon={<plume.glyphs.stroke.Download size={16} />}
                >
                  Télécharger
                </plume.RoundButton>
              </figcaption>
            </figure>
          ))}
        </div>
      </Container>
    </section>
  )
}
